import { IClubGame, TableType } from "@soposopo/sopo-models";

export interface IClubLobbyState {
    games: {
        [id: string]: IStateClubGame
    }
    unionGames: {
        [clubId: string]: {[id: string]: IStateClubGame}
    }
    selectedFilter: string;
    isUnionSelected: boolean;
}

export interface IStateClubGame extends IClubGame {
    clubId: string;
}

export const INIT_CLUB_GAME_STATE: IStateClubGame = {
    type: TableType.RING,
    name: '',
    id: '',
    dateCreated: null,
    playerCount: 0,
    clubId: '',
};

export const INIT_CLUB_LOBBY_STATE: IClubLobbyState = {
    games: {},
    unionGames: {},
    selectedFilter: 'All',
    isUnionSelected: false,
};
